/**
 * DropdownMenu content panel style utilities.
 * @internal Used by DropdownMenuContent.
 */

import { cn } from "@/utils/cn";

/** Content panel chrome — positioning is applied via portal fixed coords. */
export function getDropdownMenuContentClasses(className?: string): string {
  return cn(
    "z-[10050] min-w-56 overflow-visible rounded-lg border border-light-lin bg-white p-1.5 shadow-lg",
    className,
  );
}
